<template>
  <div class="department-container">
    <v-layout row wrap>
      <v-flex lg5 md5 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">ADD DEPARTMENT</h1>
              <div class="title-decoration"></div>
            </div>
            <v-container>
              <v-form @submit.prevent="postDepartment()">
                <v-text-field
                  label="Name"
                  v-model="department.name"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-text-field>
                <v-textarea
                  label="Description"
                  v-model="department.description"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-textarea>
                <v-btn 
                  depressed 
                  block 
                  type="submit" 
                  v-if="edit === false" 
                  class="futuristic-btn primary-btn"
                >
                  Add Department
                </v-btn>
                <v-btn 
                  depressed 
                  block 
                  type="submit" 
                  v-if="edit === true" 
                  class="futuristic-btn warning-btn"
                >
                  Update Department
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg7 md7 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">DEPARTMENTS</h1>
              <div class="title-decoration"></div>
            </div>
            <v-container>
              <div class="table-responsive">
                <table class="futuristic-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(department, index) in allDepartments" :key="index">
                      <td>{{index + 1}}</td>
                      <td>{{department.name}}</td>
                      <td>{{department.description}}</td>
                      <td>
                        <v-btn 
                          depressed 
                          small 
                          v-if="edit === false" 
                          @click="editDepartment(department)" 
                          class="futuristic-btn warning-btn action-btn"
                        >
                          Edit
                        </v-btn>
                        <v-btn 
                          depressed 
                          small 
                          v-if="edit === false" 
                          @click="deleteDepartment(department.public_id)" 
                          class="futuristic-btn error-btn action-btn"
                        >
                          Disable
                        </v-btn>
                        <v-btn 
                          depressed 
                          small 
                          v-if="edit === true" 
                          @click="cancelEdit()" 
                          class="futuristic-btn error-btn action-btn"
                        >
                          Cancel Edit
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'staff-settings',
  data () {
    return {
      edit: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      department: {
        name: '',
        description: '',
        public_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_departments')
  },
  methods: {
    editDepartment: function (department) {
      this.edit = true
      this.department.name = department.name
      this.department.description = department.description
      this.department.public_id = department.public_id
    },
    cancelEdit: function () {
      this.edit = false
      this.department.name = ''
      this.department.description = ''
      this.department.public_id = ''
    },
    postDepartment: function () {
      var instance = this
      if (this.edit === false) {
        this.$store.dispatch('post_department', this.department).then(function () {
          instance.cancelEdit()
        })
      } else {
        this.$store.dispatch('update_department', this.department).then(function () {
          instance.cancelEdit()
        })
      }
    },
    deleteDepartment: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_department', data)
    }
  }
}
</script>

<style scoped>
.department-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.department-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 80px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
  margin-bottom: 20px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  margin-bottom: 16px;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 4px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.primary-btn {
  background: linear-gradient(45deg, #587e27, #4caf50) !important;
  color: white !important;
}

.warning-btn {
  background: linear-gradient(45deg, #ff9800, #ffc107) !important;
  color: white !important;
}

.error-btn {
  background: linear-gradient(45deg, #f44336, #ff5252) !important;
  color: white !important;
}

.action-btn {
  margin: 2px;
}

.table-responsive {
  overflow-x: auto;
}

.futuristic-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
}

.futuristic-table th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
  padding: 12px;
  text-align: left;
}

.futuristic-table td {
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-table tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table tr:hover {
  background-color: #f0f4f8;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .department-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }
}

@media (max-width: 600px) {
  .department-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }
  
  .futuristic-table th,
  .futuristic-table td {
    padding: 8px;
  }
}
</style>